const searchResults = document.querySelector('[data-component="mod-search-results"][data-search-term]');

if (searchResults) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'search',
    search_term: searchResults.dataset.searchTerm,
  });
}
